
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tunisianow",
      function () {
        return require("private-next-pages/tunisianow.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tunisianow"])
      });
    }
  